import { profile } from '../data/profile';
import { Reveal } from '../components/Reveal';
import { MagneticButton } from '../components/MagneticButton';
import { ArrowRightIcon } from '../components/icons';
import './CTA.css';

export function CTA() {
  return (
    <section className="cta">
      <div className="cta-glow" aria-hidden="true" />
      <Reveal className="cta-inner">
        <p className="eyebrow">{"// Let's connect"}</p>
        <h2 className="cta-title">
          Let's build something <span className="grad">together</span>
        </h2>
        <p className="cta-subtitle">
          Have a project in mind or want to collaborate? My inbox is always open.
        </p>
        <MagneticButton className="btn btn-primary" href={`mailto:${profile.socials.email}`}>
          Get in touch <ArrowRightIcon />
        </MagneticButton>
      </Reveal>
    </section>
  );
}
